/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // Recharge-Subscription-Widget: englische Selling-Plan-Namen ins Deutsche uebersetzen.
  // Recharge benennt die Plaene z.B. "Delivery every 1 month with 30% discount" und
  // laesst sie sich dort nicht umbenennen -> der angezeigte Text wird hier ersetzt.
  // Muster-Match (nicht exakt), damit Zusaetze wie "with 30% discount" egal sind.
  function germanizeFrequency(text) {
    var t = (text || '').toLowerCase();
    if (t.indexOf('every 1 month') !== -1) return 'Lieferung jeden Monat';
    if (t.indexOf('every 2 month') !== -1) return 'Lieferung alle 2 Monate';
    if (t.indexOf('every 3 month') !== -1) return 'Lieferung alle 3 Monate';
    return null;
  }

  function translateRechargeLabels() {
    // Alle <option> im Recharge-Widget (Frequenz-Dropdown) erfassen, unabhaengig von
    // der genauen Unterklasse.
    var options = document.querySelectorAll(
      '.rc-widget-injection-parent option, .rc-selling-plans option, ' +
      '.rc_widget__option__plans__dropdown option, .rc-selling-plans__dropdown option'
    );
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var german = germanizeFrequency(opt.textContent);
      // Nur ersetzen, wenn der Text eine englische Frequenz nennt. Deutsche Texte
      // enthalten kein "every N month" -> germanizeFrequency() gibt null, kein Endlos-Loop.
      if (german && opt.textContent !== german) {
        opt.textContent = german;
      }
    }
  }

  function initRechargeTranslation() {
    translateRechargeLabels();
    // Recharge injiziert das Widget asynchron und rendert es bei Bundle-/Varianten-
    // Wechsel neu -> ein Observer haelt die Uebersetzung dauerhaft aktuell.
    var observer = new MutationObserver(translateRechargeLabels);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRechargeTranslation);
  } else {
    initRechargeTranslation();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// window.SLIDECART_OPENED = function() {  

//   var getVid = $('.cartinfo_popover_box.active_box').attr('data-variantid');    

//   if (getVid) {
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data : { id: getVid, quantity: 1 },
//       dataType: 'json',     
//       error: function(a,b) {
//         console.log(a);
//         console.log(b);
//       },
//       success: () => {
//         $('.cartinfo_popover_box').removeClass('active_box');
//         $('#ATCbtn').removeAttr('data-upsellvariantid');
//         $('.cartplus').show();
//         $('.carttick').hide();

//         // setTimeout(function() {
//         // window.SLIDECART_UPDATE()
//         // },1000)
//       }  
//     }); 
//   }

// }

window.SLIDECART_UPDATED = chktoothpro


let isSendingRequest = false

function chktoothpro(cart) {  

  var getVid = $('.cartinfo_popover_box.active_box').attr('data-variantid');  
  console.log("getVId: " + getVid)
  if (isSendingRequest) return 

  if (getVid) {
    console.log('test')
    isSendingRequest = true
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data : { id: getVid, quantity: 1 },
      dataType: 'json',     
      error: function(a,b) {
        console.log(a);
        console.log(b);
      },
      success: (cart) => {
        console.log("added: " + getVid)
        $('.cartinfo_popover_box').removeClass('active_box');
        $('#ATCbtn').removeAttr('data-upsellvariantid');
        $('.cartplus').show();
        $('.carttick').hide();
        isSendingRequest = false
        //window.SLIDECART_SET_CART(cart) 
        window.SLIDECART_UPDATE()
      }  
    }); 
  }

}
/* ---------------------------------------------------------------
   Lazy-Autoplay-Videos (snippets/image-background.liquid, video_src)
   Ersetzt z. B. das alte 2-MB-GIF: Video lädt/spielt erst, wenn es in
   die Nähe des Sichtbereichs kommt, pausiert außerhalb. Klasse
   "lazyloaded" am Wrapper löst dieselbe Einblend-/Zoom-Animation aus
   wie bei den lazysizes-Bildern.
---------------------------------------------------------------- */
(function () {
  function initLazyVideos(root) {
    var videos = (root || document).querySelectorAll('video.lazy-autoplay-video:not([data-lazy-video-init])');
    Array.prototype.forEach.call(videos, function (v) {
      v.setAttribute('data-lazy-video-init', '');
      var wrap = v.parentElement;
      var shown = false;
      var show = function () { if (!shown && wrap) { shown = true; wrap.classList.add('lazyloaded'); } };
      v.addEventListener('loadeddata', show);
      v.addEventListener('playing', show);
      var inView = false;
      var play = function () {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        setTimeout(show, 3000);
      };
      /* erneuter Startversuch, falls der erste play() vom Browser verworfen wurde (z. B. Tab kurz im Hintergrund) */
      var retry = function () { if (inView && v.paused && document.visibilityState !== 'hidden') play(); };
      v.addEventListener('canplay', retry);
      document.addEventListener('visibilitychange', retry);
      if (!('IntersectionObserver' in window)) { inView = true; play(); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView) { play(); } else if (!v.paused) { v.pause(); }
        });
      }, { rootMargin: '200px 0px' }).observe(v);
    });
  }
  initLazyVideos(document);
  document.addEventListener('shopify:section:load', function (e) { initLazyVideos(e.target); });
})();
